// extracted by mini-css-extract-plugin
export default {"status_box":"StatusBox_status_box__CdG+X"};